import { Fragment } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

// Privacy · Terms of use · Support — centered at the bottom of every footer, on every domain.
// Relative paths: /privacy, /termsofuse and /support exist on every host, so the domain never changes.
export const LEGAL_PAGES = [
  { to: "/privacy", key: "privacy" },
  { to: "/termsofuse", key: "terms" },
  { to: "/support", key: "support" },
];

export default function LegalLinks({ className = "" }) {
  const { t } = useLang();
  return (
    <p className={className} data-testid="legal-links">
      {LEGAL_PAGES.map((p, i) => (
        <Fragment key={p.to}>
          {i > 0 && <span aria-hidden="true" className="mx-2 opacity-60">·</span>}
          <Link
            to={p.to}
            data-testid={`legal-link-${p.key}`}
            className="whitespace-nowrap underline-offset-[3px] hover:underline"
          >
            {t.common[p.key]}
          </Link>
        </Fragment>
      ))}
    </p>
  );
}
